import { orderBy, cloneDeep } from 'lodash';

const INITIAL_DEFAULT_STATE = {
  mode: 'normal', //pledge - 확약서
  getGroupPersDiv: '',
  bookingList: [],
};

const state = {
  ...cloneDeep(INITIAL_DEFAULT_STATE),
};

const mutations = {
  RESET_PAYMENT(state) {
    Object.assign(state, cloneDeep(INITIAL_DEFAULT_STATE));
  },
  UPDATE_MODE(state, payload) {
    state.mode = payload;
  },
  UPDATE_BOOKING_LIST(state, payload) {
    //진로설계관은 체험자 수 기준으로 정렬하고 회차 할인
    const courseSort = (item) => 1000 - item.includeList.reduce((a, c) => a + c.pcnt, 0);
    const sorted = orderBy(
      payload,
      [(item) => item.pdDiv, (item) => (item.pdDiv === '03' ||item.pdDiv === '20'? courseSort(item) : item.mrktnPdNo), (item) => item.mrktnScheSeqNo],
      'asc',
    );

    let isYcInclude = ['01', '02'].includes(sorted?.[0].pdDiv);

    //multiDiscountYn
    for (let i = 1; i < sorted.length; i++) {
      const before = sorted[i - 1];
      const current = sorted[i];
      const multiDiscountYn = current.groupPersDiv === '01' ? 'N' : 'Y';

      //어체청체 있는지 확인
      if (['01', '02'].includes(current.pdDiv)) {
        isYcInclude = true;
      }

      if (current.mrktnPdYn === 'N') {
        if (before.mrktnPdNo === current.mrktnPdNo && before.mrktnScheSeqNo < current.mrktnScheSeqNo) {
          current.multiDiscountYn = multiDiscountYn;
        } else if (isYcInclude && current.pdDiv === '03') {
          current.multiDiscountYn = multiDiscountYn;
        } else if (isYcInclude && current.pdDiv === '20') {
          current.multiDiscountYn = multiDiscountYn;
        }else if (before.pdDiv === '03' && current.pdDiv === '03') {
          current.multiDiscountYn = multiDiscountYn;
        }else if (before.pdDiv === '20' && current.pdDiv === '20') {
          current.multiDiscountYn = multiDiscountYn;
        }
      }
    }

    state.bookingList = sorted;
  },
  UPDATE_BOOKING_PRICE(state, payload) {
    if (Array.isArray(state.bookingList) && Array.isArray(payload)) {
      payload.forEach((e) => {
        const booking = state.bookingList.find((booking) => booking.cartNo === e.cartNo);
        if (booking) {
          booking.originPrice = e.originPrice;
          booking.saleAmt = e.saleAmt;
        }
      });
    }
  },
};

const actions = {
  updateBookingList({ commit }, { bookingList, mode = 'normal' }) {
    const newBookingList = [...bookingList];
    commit('UPDATE_MODE', mode);
    commit('UPDATE_BOOKING_LIST', newBookingList);
  },
  updateBookingPrice({ commit }, priceList) {
    commit('UPDATE_BOOKING_PRICE', priceList);
  },
  clearPayment({ commit }) {
    commit('RESET_PAYMENT');
  },
};

const getters = {
  bookingList: (state) => state.bookingList,
};

const paymentModule = { state, mutations, actions, getters };

export default paymentModule;
